import NotFound from "../templates/notFound/NotFound";

const NotFoundScreen = () => {
  return <NotFound />;
};

export default NotFoundScreen;
